var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is.loaded)?_c('app-page',{attrs:{"blank":_vm.page.template === 'landing'}},[(!_vm.page.template)?_c('com-text'):_vm._e(),(_vm.page.template === 'landing')?_c('com-landing'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }